const translations = {
  button: "Out of office period for {expertName}"
};

export default translations;
